import { isProduction, isDevelopment, currentEnv } from '../../utils/env';
import urls from './urls';

export const loadApiScript = (scriptId, accountid, userId) => {
	let script = document.getElementById(scriptId);
	if (script) {
		return script;
	}
	const head = document.getElementsByTagName('head')[0] || document.documentElement;
	script = document.createElement('script');
	script.type = 'text/javascript';
	script.id = scriptId;
	script.src = urls.apiJs();
	script.async = true;
	script.dataset.account = accountid;
	script.dataset.user = userId;
	if (!isProduction()) {
		script.dataset.env = isDevelopment() ? 'dev' : currentEnv;
	}

	head.appendChild(script);

	return script;
};
